import React from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, MapPin, ShieldCheck } from "lucide-react";

const compact = (n) => (n == null ? null : Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 }).format(n));

export function PublicCreatorCard({ c }) {
  const top = [...(c.verified_stats || [])].sort((a, b) => (b.followers || 0) - (a.followers || 0))[0];
  const owner = (c.verified_stats || []).some((s) => s.owner_verified);
  return (
    <article className="rounded-2xl border border-border bg-surface p-5 flex flex-col" data-testid={`public-creator-card-${c.slug}`}>
      <div className="flex items-center gap-3">
        <img src={c.picture} alt={`${c.name} profile photo`} loading="lazy" width="56" height="56" className="h-14 w-14 rounded-full object-cover border border-border" referrerPolicy="no-referrer" />
        <div className="min-w-0">
          <h3 className="font-heading font-bold truncate"><Link to={`/creators/${c.slug}`} className="hover:text-brand-pink">{c.name}</Link></h3>
          {(c.city || c.country) && <p className="text-xs text-muted-foreground flex items-center gap-1"><MapPin className="h-3 w-3" />{[c.city, c.country].filter(Boolean).join(", ")}</p>}
        </div>
      </div>
      {owner && <span className="mt-3 self-start inline-flex items-center gap-1 rounded-full bg-neon-lime/15 border border-neon-lime/40 text-neon-lime px-2 py-0.5 text-[11px] font-bold"><ShieldCheck className="h-3 w-3" /> Owner-verified</span>}
      <p className="mt-3 text-sm text-muted-foreground line-clamp-2">{c.bio}</p>
      <dl className="mt-3 text-xs space-y-1">
        {c.categories.length > 0 && <div><dt className="inline text-muted-foreground">Categories: </dt><dd className="inline">{c.categories.join(", ")}</dd></div>}
        {c.languages.length > 0 && <div><dt className="inline text-muted-foreground">Languages: </dt><dd className="inline">{c.languages.join(", ")}</dd></div>}
        {c.platforms.length > 0 && <div><dt className="inline text-muted-foreground">Platforms: </dt><dd className="inline">{c.platforms.join(", ")}</dd></div>}
      </dl>
      <div className="mt-auto pt-4 text-sm">
        {top?.followers != null ? (
          <p className="flex items-center gap-1"><BadgeCheck className="h-4 w-4 text-neon-cyan" /><span className="font-bold">{compact(top.followers)}</span> on {top.platform}
            <span className="text-xs text-muted-foreground">· {top.source}{top.last_synced ? `, ${top.last_synced.slice(0, 10)}` : ""}</span></p>
        ) : c.followers ? (
          <p><span className="font-bold">{compact(c.followers)}</span> followers <span className="text-xs text-muted-foreground">· self-reported</span></p>
        ) : null}
        <Link to={`/creators/${c.slug}`} className="mt-2 inline-block text-brand-pink font-semibold text-sm">View profile →</Link>
      </div>
    </article>
  );
}
